interface Certification {
  title: string;
  issuer: string;
  issued: string;
  appliedAt?: string;
  credentialUrl?: string;
  badgeTitle: string;
  badgeMark: string;
  skills: string[];
}

function Certifications(): JSX.Element {
  const certifications: Certification[] = [
    {
      title: "Enterprise AI Business Solutions",
      issuer: "IBM SkillsBuild",
      issued: "2026",
      appliedAt: "Fuel2",
      badgeTitle: "Enterprise AI",
      badgeMark: "IBM",
      skills: [
        "Artificial Intelligence (AI)",
        "Business Efficiency",
        "Career Management",
        "Collaboration",
        "Critical Thinking",
        "Decision Making",
        "Emerging Technologies",
        "Enterprise Integration",
        "Organizational Effectiveness",
        "Planning",
        "Suitability Analysis",
        "Written Communication Skills"
      ]
    },
    {
      title: "CS50's Introduction to Artificial Intelligence with Python",
      issuer: "CS50, Harvard University",
      issued: "2026",
      credentialUrl: "https://cs50.harvard.edu/certificates/e518b687-07a1-49c9-bfd5-73fa0c721837",
      badgeTitle: "Introduction to AI",
      badgeMark: "CS50",
      skills: [
        "Artificial Intelligence",
        "Python",
        "Project-based Learning",
        "Twelve Projects"
      ]
    }
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Certifications</h2>
      <p className="text-gray-600 mb-6">
        Professional credentials and verified skill evidence
      </p>

      <div className="space-y-6">
        {certifications.map((certification: Certification) => (
          <article
            key={`${certification.issuer}-${certification.title}`}
            className="overflow-hidden rounded-xl border border-blue-200 bg-blue-50"
          >
            <div className="grid gap-6 p-6 md:grid-cols-[9rem_1fr] md:items-start">
              <div
                className="flex h-36 w-36 flex-col justify-between rounded-lg bg-gradient-to-br from-sky-300 via-blue-500 to-blue-900 p-4 text-white shadow-md"
                aria-hidden="true"
              >
                <span className="text-xs font-medium uppercase tracking-wide">
                  {certification.badgeTitle}
                </span>
                <span className="text-3xl font-bold">{certification.badgeMark}</span>
              </div>

              <div>
                <div className="mb-5">
                  <p className="text-sm font-semibold uppercase tracking-wide text-blue-700">
                    {certification.issuer}
                  </p>
                  <h3 className="mt-1 text-xl font-bold text-gray-900">
                    {certification.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-600">
                    Issued {certification.issued}
                  </p>
                  {certification.appliedAt && (
                    <p className="mt-1 text-sm font-medium text-blue-700">
                      Skills applied at {certification.appliedAt}
                    </p>
                  )}
                  {certification.credentialUrl && (
                    <a
                      href={certification.credentialUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-3 inline-flex text-sm font-semibold text-blue-700 hover:text-blue-900 hover:underline"
                    >
                      View certificate
                    </a>
                  )}
                </div>

                <div>
                  <h4 className="mb-3 font-semibold text-gray-800">
                    Verified skills
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {certification.skills.map((skill: string) => (
                      <span
                        key={skill}
                        className="rounded-full border border-blue-200 bg-white px-3 py-1 text-sm text-blue-800"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Certifications;
